<div class="container">
  <ecp-loader *ngIf="loading$ | async" [fluid]="true"></ecp-loader>
  <ng-container *ngIf="realignmentorders$ | async; else nOrders">
    <div *ngFor="let order of realignmentorders$ | async | searchList: searchTerm">
      <ecp-realignment-orders-detail-card [order]="order"></ecp-realignment-orders-detail-card>
    </div>
  </ng-container>
</div>
<ng-template #nOrders>
  <div class="row">
    <div class="col s12">
      <mat-card class="mat-card--widget">
        <mat-card-header>
          <h2 mat-card-title>Check back soon</h2>
        </mat-card-header>
        <mat-card-content class="offers-list__empty">
          <div class="container text-center">
            <h3 class="h3">No Orders Currently Available</h3>
            <p>Sorry, no orders are currently available to you.</p>
            <a routerLink="/" class="btn btn-link">Return to my catalog</a>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</ng-template>
